import { loopTheme } from './loopTheme';
import type { Theme } from './ThemeTypes';
import { utilitaTheme } from './utilitaTheme';

export interface ThemeEntry {
  name: 'Loop' | 'Utilita';
  theme: Theme;
}

export const availableThemes: ThemeEntry[] = [
  {
    name: 'Loop',
    theme: loopTheme,
  },
  {
    name: 'Utilita',
    theme: utilitaTheme,
  },
];
